import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-uitleg-bank-transacties-downloaden',
  styleUrls: ['./uitleg-banktransacties-downloaden.component.scss'],
  templateUrl: './uitleg-banktransacties-downloaden.component.html',
})
export class UitlegBanktransactiesDownloadenComponent implements OnInit {

  bank: string;


  constructor(private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => this.bank = params['bank']);
  }

}
